import { getAuthToken, gotoLogin, storage, isSwitcherStudioAppShell } from './utils';

const AUTOLOGIN_STATE = 'autologin';

export function bootstrapOAuthTokenExchange() {
  // Decode query string
  const query = window.location.search.substring(1);
  var params = {};
  query.split('&').forEach((v) => {
    const pair = v.split('=');
    params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  });

  // Look to see if we're being redirected here by a third-party oauth response
  if (params['oauth_reply_from']) {
    return handleThirdPartyResponse(params);
  }

  // Look to see if we're being redirected here by the BoxCast login redirect
  if (params['code'] && params['state']) {
    let authUrl = isSwitcherStudioAppShell ? SWITCHER_AUTH_URL : AUTH_URL;
    authUrl
      .substring(authUrl.indexOf('?') + 1)
      .split('&')
      .forEach((v) => {
        const pair = v.split('=');
        params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      });
    return handleLoginServerResponse(params);
  } else if (params['error']) {
    storage.clear();
    var error_url = LOGIN_URL + '/error?error=' + params['error'];
    if (params['error_description'])
      error_url += '&error_description=' + params['error_description'];
    if (params['error_hint']) error_url += '&error_hint=' + params['error_hint'];
    window.location.replace(error_url);
    throw new Error('halt');
    return $.Deferred();
  }

  // Utilize redirect-dance and localStorage to authenticate a user via OAuth
  // In some cases, we are embedded inside the Switcher Studio app; look there for a token as well.
  let token = getAuthToken();

  // If we've gotten a token in the URL, grab it then kill the URL to remove visibilty of the token.
  var hashParams = _.object(
    _.map(window.location.hash.replace(/^#/, '').split('&'), (e) => e.split('='))
  );
  if (hashParams['token_type'] == 'bearer') {
    token = hashParams['access_token'];
    if (token && token.length > 0) {
      console.log('Token captured; resuming normal activity');
      if (isSwitcherStudioAppShell) {
        document.switcherStudioAccessToken = token;
        storage.setPromise('oauthToken', token).then(() => {
          window.location.replace('/#/switcher-studio');
        });
        return;
      } else {
        storage.set('oauthToken', token);
        var path =
          storage.get('oauthPath') ||
          (hashParams['path'] && decodeURIComponent(hashParams['path'])) ||
          '/';
        storage.remove('oauthPath');
        window.location.replace(path);
      }
    }
  }

  if (token) {
    // all good, move along
    storage.bumpLoggedInCookie();
    return;
  } else if (isSwitcherStudioAppShell) {
    return storage
      .getPromise('oauthToken')
      .then((token) => {
        if (token) {
          document.switcherStudioAccessToken = token;
          window.location.replace('/#/switcher-studio');
        } else {
          gotoLogin('from storage lookup but missing token');
        }
      })
      .catch((err) => {
        console.error('Error looking for token', err);
        gotoLogin('from token error: ' + err);
        throw err;
      });
  } else {
    // token not found, redirect over to login
    gotoLogin('from token now found and not identified as switcher');
  }
}

function handleLoginServerResponse(params) {
  return storage
    .getPromise('oauthState')
    .then((state) => {
      if (params['state'] !== state && params['state'] != AUTOLOGIN_STATE) {
        console.error('Returned state', params['state'], 'does not match stored state', state);
        storage.remove('oauthState');
        storage.remove('oauthVerifier');
        storage.remove('oauthPath');
        throw new Error('Unable to complete login due to mismatched state.');
      }
      return storage.getPromise('oauthVerifier');
    })
    .then((verifier) => {
      let code = params['code'];
      let data =
        'grant_type=authorization_code&client_id=' +
        params['client_id'] +
        '&redirect_uri=' +
        params['redirect_uri'] +
        '&code=' +
        code;
      if (params['state'] != AUTOLOGIN_STATE) {
        data += '&code_verifier=' + verifier;
      }
      let post = $.ajax(TOKEN_URL, { method: 'POST', data: data });
      post.done((resp) => {
        if (resp.token_type === 'bearer') {
          let token = resp.access_token;
          if (token && token.length > 0) {
            storage.set('oauthToken', token);
            storage.bumpLoggedInCookie();
            if (isSwitcherStudioAppShell) {
              window.location.replace('/#/switcher-studio');
            } else {
              var path = storage.get('oauthPath') || '/';
              storage.remove('oauthPath');
              window.location.replace(path);
            }
            throw new Error('halt');
          }
        }
      });
      post.fail((resp) => {
        console.error('Error processing authorization callback: ', resp);
        var error = 'unknown_error';
        var error_description = 'An unknown error occurred; network status code ' + resp.status;
        var error_hint = '';
        var err = $.parseJSON(resp.responseText);
        if (typeof err === 'object') {
          if (err['error']) error = err['error'];
          if (err['error_description']) error_description = err['error_description'];
          if (err['error_hint']) error_hint = err['error_hint'];
        }
        storage.clear();
        window.location.replace(
          LOGIN_URL +
            '/error?error=' +
            encodeURIComponent(error) +
            '&error_description=' +
            encodeURIComponent(error_description) +
            '&error_hint=' +
            encodeURIComponent(error_hint) +
            '&link=' +
            encodeURIComponent('Return to BoxCast Dashboard') +
            '&href=' +
            encodeURIComponent(
              window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : '')
            )
        );
        throw new Error('halt');
      });
      return post;
    });
}

function handleThirdPartyResponse(params) {
  const thirdParty = params['oauth_reply_from'];
  switch (thirdParty) {
    case 'youtube':
      if (params['code']) {
        // Go to /settings/youtube with code
        const code = params['code'],
          l = window.location;
        window.location.replace(
          `${l.protocol}//${l.host}${l.pathname}#/settings/youtube?code=${code}`
        );
        throw 'halt';
      } else if (params['error']) {
        const error = params['error'],
          l = window.location;
        window.location.replace(
          `${l.protocol}//${l.host}${l.pathname}#/settings/youtube?error=${error}`
        );
        throw 'halt';
      } else {
        console.log(`Missing 'code' parameter for YouTube oauth; going home.`);
        window.location.replace('/');
        throw 'halt';
      }
      break;
    case 'vimeo':
      if (params['code']) {
        // Go to /settings/vimeo with code
        const code = params['code'],
          l = window.location;
        window.location.replace(
          `${l.protocol}//${l.host}${l.pathname}#/settings/vimeo?code=${code}`
        );
        throw 'halt';
      } else {
        console.log(`Missing 'code' parameter for Vimeo oauth; going home.`);
        window.location.replace('/');
        throw 'halt';
      }
      break;
    default:
      console.log(`Unknown thirdParty oauth provider: ${thirdParty}; going home.`);
      window.location.replace('/');
      throw 'halt';
  }
}



// WEBPACK FOOTER //
// ./app/auth/bootstrap.js